import { render, staticRenderFns } from "./VueSelect2.vue?vue&type=template&id=30b64044&scoped=true&"
import script from "./VueSelect2.vue?vue&type=script&lang=js&"
export * from "./VueSelect2.vue?vue&type=script&lang=js&"
import style0 from "./VueSelect2.vue?vue&type=style&index=0&id=30b64044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b64044",
  null
  
)

export default component.exports